import { useCallback, useEffect, useRef } from "react"

import { BrushCleaning } from "lucide-react"
import { Button, DefaultTooltip } from "twyne-new.ui"

import { useUsedColors } from "@/components/builder/utils/tailwindConfig/hooks"

import { usePalette } from "./context"

const removeDuplicates = array => {
  const unique = Array.from(new Set(array.map(i => typeof i !== 'string' ? JSON.stringify(i) : i))).map(i => {
    try {
      return JSON.parse(i)
    } catch {
      return i
    }
  })
  return unique
}

const useAddUsedColor = () => {
  const { selectedColor } = usePalette()
  const { value: usedColors, setValue: setUsedColors } = useUsedColors()
  const initialColor = useRef()
  const currentColor = useRef()
  const usedColorsRef = useRef(usedColors)

  const addColor = useCallback(newColor => {
    if (!newColor) return
    setUsedColors(removeDuplicates([...usedColorsRef.current, newColor]))
  }, [setUsedColors])

  useEffect(() => {
    usedColorsRef.current = usedColors
  }, [usedColors])

  useEffect(() => {
    currentColor.current = selectedColor
    if (initialColor.current === undefined && selectedColor !== undefined) {
      initialColor.current = selectedColor
      addColor(selectedColor)
    }
  }, [selectedColor, addColor])

  useEffect(() => () => {
    if (currentColor.current) {
      addColor(currentColor.current)
    }
  }, [addColor])
}

const ClearUsedColorsButton = () => {
  const { value: usedColors, setValue: setUsedColors } = useUsedColors()

  const handleClear = () => {
    setUsedColors([])
  }

  if (!usedColors.length) {
    return null
  }

  return <DefaultTooltip content='Clear used colors' triggerProps={{ asChild: true }}>
    <Button onClick={handleClear} className='w-fit absolute left-[29%] py-px bottom-[14.5%]' variant='light' size='sm'> <BrushCleaning size='14' /> </Button>
  </DefaultTooltip>
}

export {
  useAddUsedColor,
  ClearUsedColorsButton,
}
